import { useQuery } from '@tanstack/react-query'
import { queryAdvertisers, QueryAdvertisersParams } from 'supabase/advertisers'

export const useQueryAdvertisers = (params: QueryAdvertisersParams = {}) => {
  const query = useQuery({
    queryKey: ['advertisers', params],
    queryFn: () => queryAdvertisers(params),
  })

  return {
    advertisers: query.data?.advertisers || [],
    count: query.data?.count || 0,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  }
}